import { render, staticRenderFns } from "./dyh-goodsSearch.vue?vue&type=template&id=f1ce2076&scoped=true&"
import script from "./dyh-goodsSearch.vue?vue&type=script&lang=js&"
export * from "./dyh-goodsSearch.vue?vue&type=script&lang=js&"
import style0 from "./dyh-goodsSearch.vue?vue&type=style&index=0&id=f1ce2076&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ce2076",
  null
  
)

export default component.exports